import React, { useEffect, useState } from 'react';
import { TennisLiveApi } from '../../services/TennisLiveApi';
import './Giro.css';

interface PlayerProfileCardProps {
  playerId: number;
  playerName: string;
}

export const PlayerProfileCard: React.FC<PlayerProfileCardProps> = ({ playerId, playerName }) => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      const data = await TennisLiveApi.getPlayerStats(playerId);
      if (data) {
        setStats(data);
      }
      setLoading(false);
    };
    fetchStats();
  }, [playerId]);

  if (loading) {
    return <div className="gr-profile-card gr-loading">Carregando dados de {playerName}...</div>;
  }

  if (!stats || !stats.stats) {
    return <div className="gr-profile-card gr-error">Dados não disponíveis para {playerName}</div>;
  }

  const { stats: matchStats } = stats;
  // A API de estatísticas traz um array com temporadas. Vamos pegar a mais recente em simples (singles).
  let currentStats = null;
  if (Array.isArray(matchStats)) {
    const singlesStats = matchStats.filter((s: any) => s.type === 'singles');
    if (singlesStats.length > 0) {
      // Sort desc by season
      singlesStats.sort((a: any, b: any) => parseInt(b.season || '0') - parseInt(a.season || '0'));
      currentStats = singlesStats[0];
    }
  }

  return (
    <div className="gr-profile-card">
      <div className="gr-profile-header">
        <h3 className="gr-profile-name">{playerName}</h3>
        <span className="gr-profile-badge">TEMPORADA {currentStats?.season || ''} - SIMPLES</span>
      </div>
      
      <div className="gr-profile-grid">
        <div className="gr-stat-item">
          <span className="gr-stat-label">Vitórias / Derrotas</span>
          <span className="gr-stat-value">{currentStats?.matches_won || '0'} - {currentStats?.matches_lost || '0'}</span>
        </div>
        <div className="gr-stat-item">
          <span className="gr-stat-label">Títulos</span>
          <span className="gr-stat-value">{currentStats?.titles || '0'}</span>
        </div>
        <div className="gr-stat-item">
          <span className="gr-stat-label">Quadra Dura (W/L)</span>
          <span className="gr-stat-value">{currentStats?.hard_won || '0'} - {currentStats?.hard_lost || '0'}</span>
        </div>
        <div className="gr-stat-item">
          <span className="gr-stat-label">Saibro (W/L)</span>
          <span className="gr-stat-value">{currentStats?.clay_won || '0'} - {currentStats?.clay_lost || '0'}</span>
        </div>
      </div>
    </div>
  );
};
